import React from "react";
import { track } from "../../utils/analytics";

const STEP_COPY = {
  roleplay: {
    title: "Role Play",
    arabic: "تدرّب على المحادثة",
    body:
      "Practise this dialogue in a live conversation with an AI speaking partner that listens, replies, and corrects you.",
  },
  quiz: {
    title: "Quiz",
    arabic: "اختبر نفسك",
    body: "Test yourself on this topic's words and dialogue to lock in what you've learnt.",
  },
};

/**
 * PublicLockedStep — the banner shown when an anonymous visitor opens a
 * locked journey step (Role Play / Quiz) on the shared-topic page. Mirrors
 * PublicIrabPage's ComingSoon card: one primary trial CTA + a sign-in link.
 */
export default function PublicLockedStep({ stepKey }) {
  const copy = STEP_COPY[stepKey] || STEP_COPY.roleplay;
  return (
    <div className="dark-scope surface-glass rounded-2xl px-6 py-10 text-center">
      <div
        className="mx-auto mb-4 flex items-center justify-center rounded-full"
        style={{ width: 52, height: 52, background: "var(--forest-soft)", border: "1px solid var(--panel-line)" }}
        aria-hidden="true"
      >
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="var(--gold-bright)" strokeWidth={1.8}>
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path strokeLinecap="round" d="M8 11V7a4 4 0 118 0v4" />
        </svg>
      </div>
      <p className="font-amiri text-3xl mb-1" style={{ color: "var(--parchment)" }} dir="rtl">
        {copy.arabic}
      </p>
      <p className="text-sm font-semibold mb-2" style={{ color: "var(--gold-bright)" }}>
        {copy.title} is part of the full journey
      </p>
      <p className="text-sm mb-6 max-w-md mx-auto" style={{ color: "var(--parchment-dim)" }}>
        {copy.body} Create a free account to continue this topic from where you left off.
      </p>
      <a
        href="/?signup=1"
        onClick={() => track("share-topic-signup-click", { step: stepKey })}
        className="inline-block px-5 py-2.5 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter] no-underline"
      >
        Start your 7-day free trial
      </a>
      <p className="mt-3 text-xs" style={{ color: "var(--parchment-dim)" }}>
        Already learning with us?{" "}
        <a href="/" className="underline hover:text-dt-gold-bright" style={{ color: "var(--parchment)" }}>
          Sign in
        </a>
      </p>
    </div>
  );
}
